import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import CreateOrderForm from './create-order-form/create-order-form';
import OrdersListing from './orders-listing/orders-listing';
import { useContext, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { UserType } from '../../../enums/users';
import { OrderType } from '../../../interfaces/delivery-company/orders';

function Orders() {
  return <OrdersListing />;
}

export default Orders;
